import { SessionRecorder, SessionRecorderEvents } from 'src/types/services/SessionRecorder';

export class SessionRecordingService {
  public isLoaded = false;
  public isClarityLoaded = false;
  public recorders: Record<'clarityRecorder', SessionRecorder | null> = {
    clarityRecorder: null,
  };
  private loadingPromise: Promise<void> | null = null;

  public identifyUser = async (id: number, username: string): Promise<void> => {
    if (!this.isLoaded) {
      await this.loadRecorders();
    }

    Object.values(this.recorders).forEach((recorder) => {
      recorder?.identifyUser({ id, username });
    });
  };

  public trackEvent = async (eventName: SessionRecorderEvents, data?: Record<string, any>): Promise<void> => {
    if (!this.isLoaded) {
      await this.loadRecorders();
    }

    Object.entries(this.recorders).forEach(([name, recorder]) => {
      try {
        recorder?.trackEvent(eventName, data);
      } catch (err) {
        console.warn(`[SessionRecorder] "${name}" recorder failed:`, err);
      }
    });
  };

  public loadClarityRecorder = async (): Promise<void> => {
    if (this.isClarityLoaded) return;

    const clarityKey = process.env.REACT_APP_CLARITY_PROJECT_KEY || '';
    if (!clarityKey) return;

    this.isClarityLoaded = true;

    try {
      const clarityModule = await import('../services/clarityRecorder');
      this.recorders.clarityRecorder = new clarityModule.ClarityRecorder();
    } catch (err) {
      console.warn('[SessionRecorder] Clarity recorder failed to load', err);
      this.recorders.clarityRecorder = null;
    }
  };

  public loadRecorders = async (): Promise<void> => {
    if (this.isLoaded) return;

    if (!this.loadingPromise) {
      this.loadingPromise = (async () => {
        await this.loadClarityRecorder();
        this.isLoaded = true;
      })();
    }

    return this.loadingPromise;
  };
}

export const sessionRecordingService = new SessionRecordingService();
